// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — page-auth.classic.js, новая — page-auth.cp.js
import { isCp } from 'libs/design';
import * as classic from './page-auth.classic';
import * as cp from './page-auth.cp';

export const PageAuth = isCp ? cp.PageAuth : classic.PageAuth;
